import { STATUS } from "@/constants/statuses";

/**
 * Function to determine loading status.
 * @param {STATUS} status
 */
export const getLoadingStatus = (status: STATUS) =>
    status === STATUS.VIRGIN ? STATUS.INITIAL_LOADING : STATUS.LOADING;
